import type { ReactNode } from "react";
import { Component } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";

class ErrorBoundary extends Component<
  { children: ReactNode } & WithTranslation,
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          {this.props.t("common.error.unknown.message", {
            defaultValue: "Что-то пошло не так",
          })}
        </div>
      );
    }
    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
